/**
 * @param {Array<*>} iterable - array to iterate over
 * @param {*} item - item in array
 * @returns {number} - last index in array
 */
export const getLastIndexById = (iterable, item) => iterable.findLastIndex(value => value.id === item.id);
